export default "__VITE_ASSET__BX7$OUVR__"